<template>
  <div class="header-boxs">
    <div class="header-left" @click="OnClickChild($event, '/home')">
      <img src="@/assets/images/log2.png" class="logo" alt="">
    </div>
    <div class="header-right">
      <div class="menu" @click="showMenuList(true)">
        <img src="@/assets/images/mobile/menu.png" alt="" class="menu-icon">
      </div>
    </div>
  </div>
  <div class="model-box" v-if="menuListState">
    <div class="model-bg" @click="showMenuList(false)">
    </div>
    <div class="header-menu-fixed">
      <div class="menu-top">
        <img src="@/assets/images/log2.png" class="logo" alt="">
        <img src="@/assets/images/mobile/close.png" class="close" @click="showMenuList(false)" alt="">
      </div>
      <ul class="menu-list">
<!--        <li>-->
<!--          <div class="menu-item" @click="OnClickChild($event, '/home')">-->
<!--            <span>Home</span>-->
<!--&lt;!&ndash;            <img src="@/assets/images/mobile/arrow1.png" alt="">&ndash;&gt;-->
<!--          </div>-->
<!--        </li>-->
        <li>
          <div class="menu-item" @click="OnClickChild($event, '/home')">
            <span :class="path == '/home' ? 'show' : ''">Home</span>
<!--            <img src="@/assets/images/mobile/arrow1.png" alt="">-->
          </div>
          <div class="sub-menu-list">
            <div class="sub-menu-item" @click="OnClickChild($event, '/home', 1)">
              <span>Board Game</span>
<!--              <img src="@/assets/images/mobile/arrow2.png" alt="">-->
            </div>
            <div class="sub-menu-item" @click="OnClickChild($event, '/home', 2)">
              <span>Crowdfunding Game</span>
              <!--              <img src="@/assets/images/mobile/arrow2.png" alt="">-->
            </div>
            <div v-if="SHOW_DIGITAL_GAME" class="sub-menu-item" @click="OnClickChild($event, '/home', 3)">
              <span>Digital Games</span>
            </div>
          </div>
        </li>
        <li>
          <div class="menu-item" @click="OnClickChild($event, '/team')">
            <span :class="path == '/team' ? 'show' : ''">Team</span>
<!--            <img src="@/assets/images/mobile/arrow1.png" alt="">-->
          </div>
        </li>
        <li>
          <div class="menu-item" @click="OnClickChild($event, '/news')">
            <span :class="path == '/news' ? 'show' : ''">News</span>
<!--            <img src="@/assets/images/mobile/arrow1.png" alt="">-->
          </div>
        </li>
        <li>
          <div class="menu-item" @click="openUrl()">
            <span>Shop</span>
          </div>
        </li>
        <li>
          <div class="menu-item" @click="OnClickChild($event, '/contact')">
            <span :class="path == '/contact' ? 'show' : ''">Contact</span>
<!--            <img src="@/assets/images/mobile/arrow1.png" alt="">-->
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, defineEmits, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router"
import { useStore } from 'vuex';
import { SHOW_DIGITAL_GAME } from '@/views/home/visibility';
const menuListState = ref(false)
const store = useStore();
const router = useRouter();
const route = useRoute()
const emit = defineEmits(['clickMenu', 'clickChildMenu'])

const path = ref('')
watch(() => route.path, (newVal) => {
  path.value = newVal
})
const OnEnter = (event) => {
  if (event.target.children.length === 1) {
    event.target.children[0].classList.remove('normal')
    event.target.children[0].classList.add('highlight')
  }
  event.target.classList.add('hover')
  event.target.classList.add('active')
}

const OnLeave = (event) => {
  if (event.target.children.length === 1) {
    event.target.children[0].classList.remove('highlight')
    event.target.children[0].classList.add('normal')
  }
  event.target.classList.remove('hover')
  event.target.classList.remove('active')
}

const OnClick = (event, id, navIndex = 0) => {
  emit('clickMenu', id)
  menuListState.value = false

  if(router.currentRoute.value.fullPath == '/'){
    // 首页直接跳转到锚点
    emit('clickMenu', id)
  }else {
    // 其他页面跳转到首页再定位锚点
    router.replace({
      path: '/home'
    })
    setTimeout(() => {
      emit('clickMenu', id)
    }, 400)
  }
  store.commit('setProductIndex', Number(navIndex))
}
const JumpContact = () => {
  menuListState.value = false
  router.push({
    path: '/contact-m'
  })
}
const OnClickChild = (event, url: string, navIndex?:number) => {

  menuListState.value = false
  router.replace({
    path: url
  })
  if(navIndex) {
    setTimeout(() => {
      emit('clickMenu', navIndex)
    }, 300)
  }
}

const showMenuList = (state: boolean) => {
  menuListState.value = state
}
const splitPath = () => {
  // console.log('window.location.pathname =====>' + window.location.pathname);
  // console.log('window.location.search =====>' + window.location.search);
  return window.location.pathname.split('/');
}



const openUrl = () => {
  window.open('https://www.walmart.com/global/seller/102762736/cp/shopall?povid=LFNav_Landing%20Page_sellerpage_cat_pill_shopall', '_blank')
  menuListState.value = false

}
</script>

<style scoped lang="less">
.header-boxs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 94%;
  margin: auto;
  //height: 1.8rem;
  padding: .4rem 0;
}
/* header left */
.header-left .logo {
  width: 5.6rem;
}


/* header right */
.header-right {
  display: flex;

  .menu-icon {
    width: 1.4rem;
  }
}
.model-box {
  .model-bg {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    z-index: 8;
  }
  .header-menu-fixed {
    position: fixed;
    background: #20272b;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99999;
    .menu-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: .1rem solid #434d55;
      padding: .4rem .75rem;
      background: #000000;
      .logo {
        width: 6.2rem;
      }
      .close {
        width: 1.4rem;
      }
    }
    .menu-list {
      padding: .6rem 1.3rem;
      color: #fff;
      >li {
        width: 100%;
        .menu-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: .7rem;
          padding: .9rem 0;
          .show {
            color: #00FC9F;
          }
          > img {
            width: .23rem;
          }
        }
        .sub-menu-list {
          padding-left: .6rem;
          margin: .6rem 0;
          border-left: 0.05rem solid  rgba(255,255,255,0.3);
          .sub-menu-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 0.7rem;
            color: #fff;
            line-height: 0.82rem;
            margin-bottom: 1.2rem;
            &:last-child {
              margin-bottom: 0;
            }
            img {
              width: .16rem;
            }
          }
        }
      }
    }
  }
}


</style>
